import { CircularProgress, styled } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useRef } from "react";
import CustomConfetti from "../CustomConfetti";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

const Root = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const LoadingContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "80px",
  marginTop: "20px",
  color: "#406288",
}));

const Content = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "20px",
}));

const SuccessActivateContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",

  gap: "30px",
  alignItems: "center",

  "& p": {
    textAlign: "center",
    maxWidth: isMobile ? "320px" : "600px",
    fontSize: isMobile ? "12px" : "16px",
    color: "#406288",
  },
}));

const FailedActivateContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "30px",
  alignItems: "center",

  "& p": {
    textAlign: "center",
    maxWidth: isMobile ? "320px" : "600px",
    fontSize: isMobile ? "12px" : "16px",
    color: "#406288",
  },
}));

const EmailConfirmationPage = ({ loading, activateSuccess }) => {
  const buttonRef = useRef();
  const { t } = useTranslation();
  useEffect(() => {
    if (!loading && activateSuccess) {
      buttonRef.current.click();
    }
  }, [activateSuccess, loading]);

  return (
    <Root>
      <CustomConfetti buttonRef={buttonRef} />
      {loading && (
        <LoadingContainer>
          <p>{t("waitingForActivateEmail")}</p>
          <CircularProgress size={70} />
        </LoadingContainer>
      )}
      {!loading && (
        <Content>
          {activateSuccess ? (
            <SuccessActivateContent>
              <p>{t("activateEmailSuccessfully")}</p>
              <img
                src={"/assets/email/email-activate-successfully.webp"}
                alt="arrow"
                width={isMobile ? "200px" : "300px"}
                style={{
                  borderRadius: "12px",
                }}
              />
            </SuccessActivateContent>
          ) : (
            <FailedActivateContent>
              <p>{t("canNotActivateEmail")}</p>
              <img
                src={"/assets/email/can-not-activate-image.webp"}
                alt="arrow"
                width={isMobile ? "200px" : "300px"}
                style={{
                  borderRadius: "12px",
                }}
              />
            </FailedActivateContent>
          )}
        </Content>
      )}
    </Root>
  );
};

export default EmailConfirmationPage;
